export const type = 'form.widgetFormRadioIcon';
